import { ITooltipAngularComp } from "@bfx/ag-grid-angular";
import { ITooltipParams, IAfterGuiAttachedParams } from "ag-grid-community";
import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DIReasonHelper } from "shared/cubiq-services/model/orders/DIReasonHelper";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CcyLookupService } from "shared/cubiq-services";

@Component({
  selector: "ops-int-tooltip",
  template: `<div class="bfx-tooltip-text" [innerHtml]="tooltip"></div>`,
  host: { class: "bfx-tooltip-grid" },
  // WIP move to SASS when ready
  styles: [
    `
      :host {
        position: absolute;
        /* border: 1px solid black; */
        /* background: white;
        color: black; */
        overflow: hidden;
        pointer-events: none;
      }

      :host.ag-tooltip-hiding {
        opacity: 0;
      }

      :host > .bfx-tooltip-text {
        white-space: pre;
        /* padding-left: 3px;
        padding-right: 3px; */
      }
    `,
  ],
  standalone: false,
})
export class OpsIntTooltip implements ITooltipAngularComp {
  public tooltip: string = "";
  private diReasonHelper: DIReasonHelper;

  constructor(
    private _translate: TranslateService,
    private _ccyLookup: CcyLookupService,
  ) {
    this.diReasonHelper = new DIReasonHelper(_translate, _ccyLookup); // no order data needed
  }

  agInit(params: ITooltipParams): void {
    // TODO expand for all DI fields
    if (params == null) {
      this.tooltip = "";
    } else if (typeof params.value === "string") {
      this.tooltip = params.value;
    } else if (params.value instanceof CubiqTS.ErrorsImpl) {
      this.tooltip = this.diReasonHelper.retrieveTooltip(params);
    }
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    if (params != null) {
      // no-op
    }
  }
}
